module.exports = __webpack_public_path__ + "img/1492809920.533c54e5.jpg";